const EARTH_RADIUS = 6371008.8;

const ringAreaM2 = (ring) => {
  if (!ring || ring.length < 3) return 0;
  const lat0 = ring.reduce((sum, p) => sum + p[1], 0) / ring.length;
  const k = Math.cos((lat0 * Math.PI) / 180);
  const pts = ring.map((p) => [(p[0] * Math.PI / 180) * k * EARTH_RADIUS, (p[1] * Math.PI / 180) * EARTH_RADIUS]);
  let total = 0;
  for (let i = 0; i < pts.length; i += 1) {
    const [x1, y1] = pts[i];
    const [x2, y2] = pts[(i + 1) % pts.length];
    total += x1 * y2 - x2 * y1;
  }
  return Math.abs(total) / 2;
};

const geometryAreaM2 = (geometry) => {
  if (!geometry) return 0;
  switch (geometry.type) {
    case 'Polygon': {
      const [outer, ...holes] = geometry.coordinates || [];
      return ringAreaM2(outer) - holes.reduce((sum, ring) => sum + ringAreaM2(ring), 0);
    }
    case 'MultiPolygon':
      return (geometry.coordinates || []).reduce((sum, poly) => sum + geometryAreaM2({ type: 'Polygon', coordinates: poly }), 0);
    case 'GeometryCollection':
      return (geometry.geometries || []).reduce((sum, g) => sum + geometryAreaM2(g), 0);
    default:
      return 0;
  }
};

export const areaHa = (geometry) => {
  const m2 = geometryAreaM2(geometry);
  return m2 ? Math.round(m2 / 100) / 100 : null;
};

export const featuresOf = (geojson) => {
  if (!geojson) return [];
  if (geojson.type === 'FeatureCollection') return geojson.features || [];
  if (geojson.type === 'Feature') return [geojson];
  return [{ type: 'Feature', properties: {}, geometry: geojson }];
};

export const geojsonAreaHa = (geojson) => {
  const total = featuresOf(geojson).reduce((sum, f) => sum + geometryAreaM2(f.geometry), 0);
  return total ? Math.round(total / 100) / 100 : null;
};

export const VMD_TOOL_URL = 'https://epak.vmd.gov.lv/tools/affirmation';
export const VMD_API_URL = 'https://epak.vmd.gov.lv/api/public/affirmation-geojson/';
